/*
 * Dynamischer Warenkorb-Upsell
 * ---------------------------------------------------------------------------
 * Zeigt im Warenkorb-Drawer und auf der Warenkorb-Seite Produkte an, die zu den
 * Artikeln im Warenkorb passen - statt einer festen Collection.
 *
 * Reihenfolge der Quellen (gestaffelt, wird nacheinander aufgefuellt):
 *   1. "Ergaenzende Produkte" aus Search & Discovery  (intent=complementary)
 *   2. Shopifys automatische Empfehlungen             (intent=related)
 *   3. Die feste Collection aus den Theme-Einstellungen (Notfall-Fallback)
 *
 * Bezugspunkt sind alle Artikel im Warenkorb, sortiert nach Stueckpreis
 * absteigend - das Zubehoer zum teuersten Artikel steht also vorne.
 * Produkte, die bereits im Warenkorb liegen, werden immer herausgefiltert.
 */
(function () {
  'use strict';

  // Das Script wird an zwei Stellen eingebunden (cart-drawer.liquid und
  // cart-upsell.liquid) - doppelte Ausfuehrung hier abfangen.
  if (window.__grillfreudeCartUpsell) return;
  window.__grillfreudeCartUpsell = true;

  var SECTION_ID = 'cart-upsell-recommendations';
  var MAX_SEED_PRODUCTS = 3; // max. Anzahl Warenkorb-Artikel, fuer die wir Empfehlungen holen
  var API_LIMIT = 10; // max. erlaubtes Limit der Recommendations-API
  var DEBOUNCE_MS = 300;

  var lastSignature = null; // Produkt-IDs im Warenkorb, fuer die zuletzt geladen wurde
  var lastRenderedHTML = null; // zuletzt gerenderte <li>-Liste (fuer Re-Placement)
  var inFlight = false;
  var debounceTimer = null;

  // ---------------------------------------------------------------------------
  // Hilfsfunktionen
  // ---------------------------------------------------------------------------

  function templateBlock() {
    var wrapper = document.getElementById('cart-drawer-upsell-wrapper');
    return wrapper ? wrapper.querySelector('.cart-drawer-upsell-block') : null;
  }

  function placedBlocks() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.cart-drawer-upsell-block--placed')
    );
  }

  function cartUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base + '.js';
  }

  function recommendationsUrl() {
    var list = document.querySelector('#cart-drawer-upsell-wrapper .cart-drawer-upsell-list');
    var fromData = list && list.getAttribute('data-recommendations-url');
    return fromData || (window.routes && window.routes.product_recommendations_url) || '/recommendations/products';
  }

  function displayLimit() {
    var list = document.querySelector('#cart-drawer-upsell-wrapper .cart-drawer-upsell-list');
    var value = list ? parseInt(list.getAttribute('data-limit'), 10) : NaN;
    if (isNaN(value) || value < 1) value = 8;
    return Math.min(value, 12);
  }

  function cloneBlock() {
    var template = templateBlock();
    if (!template) return null;
    var clone = template.cloneNode(true);
    clone.removeAttribute('id');
    clone.classList.add('cart-drawer-upsell-block--placed');
    return clone;
  }

  // ---------------------------------------------------------------------------
  // Platzierung (idempotent - kann jederzeit erneut aufgerufen werden)
  // ---------------------------------------------------------------------------

  function placeInDrawer() {
    var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items');
    if (!cartDrawerItems) return;
    if (cartDrawerItems.classList.contains('is-empty')) return;

    var wrapper = document.querySelector('#CartDrawer .cart-drawer-items-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.classList.add('cart-drawer-items-wrapper');
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems);
      wrapper.appendChild(cartDrawerItems);
    }

    if (wrapper.querySelector('.cart-drawer-upsell-block--placed')) return;

    var block = cloneBlock();
    if (!block) return;
    block.classList.add('cart-drawer-upsell-block--drawer');
    wrapper.appendChild(block);
  }

  function placeInCartPage() {
    var cartItems = document.querySelector('#MainContent cart-items');
    if (!cartItems) return;

    var host = cartItems.querySelector('.page-width') || cartItems;
    if (host.querySelector('.cart-drawer-upsell-block--placed')) return;

    var block = cloneBlock();
    if (!block) return;
    block.classList.add('cart-drawer-upsell-block--page');
    host.appendChild(block);
  }

  function placeAll() {
    placeInDrawer();
    placeInCartPage();
    if (lastRenderedHTML !== null) applyHTML(lastRenderedHTML);
  }

  function applyHTML(html) {
    placedBlocks().forEach(function (block) {
      var list = block.querySelector('.cart-drawer-upsell-list');
      if (!list) return;
      if (list.innerHTML === html) return;
      list.innerHTML = html;
      block.hidden = html.trim() === '';
    });
  }

  function removeAll() {
    placedBlocks().forEach(function (block) {
      block.parentNode.removeChild(block);
    });
  }

  // ---------------------------------------------------------------------------
  // Daten holen
  // ---------------------------------------------------------------------------

  function fetchCart() {
    return fetch(cartUrl(), { headers: { Accept: 'application/json' } }).then(function (res) {
      if (!res.ok) throw new Error('cart fetch failed');
      return res.json();
    });
  }

  function fetchRecommendations(productId, intent) {
    var url =
      recommendationsUrl() +
      '?section_id=' +
      encodeURIComponent(SECTION_ID) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&limit=' +
      API_LIMIT +
      '&intent=' +
      encodeURIComponent(intent);

    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('recommendations fetch failed');
        return res.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('li[data-upsell-product-id]'));
      })
      .catch(function () {
        return [];
      });
  }

  // ---------------------------------------------------------------------------
  // Auswahl
  // ---------------------------------------------------------------------------

  // Nimmt abwechselnd aus jeder Gruppe (Round Robin), damit nicht ein einziges
  // Warenkorb-Produkt die gesamte Liste belegt. Reihenfolge der Gruppen =
  // Warenkorb-Artikel nach Stueckpreis absteigend.
  function interleave(groups, taken, limit) {
    var picked = [];
    var maxLength = groups.reduce(function (max, group) {
      return Math.max(max, group.length);
    }, 0);

    for (var i = 0; i < maxLength && picked.length < limit; i++) {
      for (var g = 0; g < groups.length && picked.length < limit; g++) {
        var item = groups[g][i];
        if (!item) continue;
        var id = item.getAttribute('data-upsell-product-id');
        if (!id || taken.indexOf(id) !== -1) continue;
        taken.push(id);
        picked.push(item);
      }
    }
    return picked;
  }

  function fallbackItems(taken, limit) {
    var template = templateBlock();
    if (!template) return [];
    var picked = [];
    var items = template.querySelectorAll('li[data-upsell-product-id]');
    for (var i = 0; i < items.length && picked.length < limit; i++) {
      var id = items[i].getAttribute('data-upsell-product-id');
      if (!id || taken.indexOf(id) !== -1) continue;
      taken.push(id);
      picked.push(items[i].cloneNode(true));
    }
    return picked;
  }

  function seedProductIds(cart) {
    var sorted = cart.items.slice().sort(function (a, b) {
      return (b.price || 0) - (a.price || 0);
    });
    var ids = [];
    sorted.forEach(function (item) {
      var id = String(item.product_id);
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    return ids.slice(0, MAX_SEED_PRODUCTS);
  }

  function loadRecommendations(cart) {
    var limit = displayLimit();
    var seeds = seedProductIds(cart);
    var taken = cart.items.map(function (item) {
      return String(item.product_id);
    });

    if (!seeds.length) return Promise.resolve([]);

    return Promise.all(
      seeds.map(function (id) {
        return fetchRecommendations(id, 'complementary');
      })
    )
      .then(function (groups) {
        var picked = interleave(groups, taken, limit);
        if (picked.length >= limit) return picked;

        return Promise.all(
          seeds.map(function (id) {
            return fetchRecommendations(id, 'related');
          })
        ).then(function (relatedGroups) {
          return picked.concat(interleave(relatedGroups, taken, limit - picked.length));
        });
      })
      .then(function (picked) {
        if (picked.length < limit) {
          picked = picked.concat(fallbackItems(taken, limit - picked.length));
        }
        return picked;
      });
  }

  // ---------------------------------------------------------------------------
  // Ablauf
  // ---------------------------------------------------------------------------

  function refresh() {
    if (inFlight) return;
    if (!templateBlock()) return;

    inFlight = true;

    fetchCart()
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) {
          lastSignature = null;
          lastRenderedHTML = null;
          removeAll();
          return null;
        }

        var signature = cart.items
          .map(function (item) {
            return item.product_id;
          })
          .sort()
          .join(',');

        placeAll();

        if (signature === lastSignature && lastRenderedHTML !== null) return null;
        lastSignature = signature;

        return loadRecommendations(cart);
      })
      .then(function (items) {
        if (items === null) return;

        if (!items.length) {
          lastRenderedHTML = '';
          applyHTML('');
          return;
        }

        var html = items
          .map(function (item) {
            return item.outerHTML;
          })
          .join('');

        lastRenderedHTML = html;
        placeAll();
        applyHTML(html);
      })
      .catch(function (error) {
        if (window.console && console.warn) console.warn('[cart-upsell]', error);
      })
      .then(function () {
        inFlight = false;
      });
  }

  function scheduleRefresh() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, DEBOUNCE_MS);
  }

  // ---------------------------------------------------------------------------
  // Variantenwechsel in der Upsell-Karte -> Bild tauschen
  // ---------------------------------------------------------------------------

  window.onChangeKsUpsellVariantSelector = function (select, event) {
    event.preventDefault();
    var option = select.options[select.selectedIndex];
    var imgSrc = option && option.dataset ? option.dataset.variantImg : null;
    if (!imgSrc) return;

    var item = select.closest('.cart-drawer-upsell-list-item');
    var img = item && item.querySelector('.cart-drawer-upsell-list-item-left img');
    if (img) img.src = imgSrc;
  };

  // ---------------------------------------------------------------------------
  // Beobachter
  // ---------------------------------------------------------------------------

  function observe(element) {
    if (!element) return;
    var observer = new MutationObserver(scheduleRefresh);
    observer.observe(element, { attributes: true, childList: true, subtree: true });
  }

  function init() {
    refresh();
    observe(document.querySelector('cart-drawer'));
    observe(document.querySelector('#MainContent cart-items'));
    document.addEventListener('cart:refresh', scheduleRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
